import gql from 'graphql-tag';
import { languageStringFrag } from './languageStringFrag';

export const formSubmissionFrag = gql`
  ${languageStringFrag}

  fragment FormSubmissionFrag on FormSubmission {
    id
    percentComplete
    percentCorrect
    startedAt
    modifiedAt
    completedAt
    form {
      id
    }
    answers {
      id
      question {
        id
        name
        questionType
        answerType
        answer
        text {
          ...LangStringFrag
        }
        options {
          id
          text
        }
      }
      answer
      translation
      originalLanguageId
      selections {
        id
      }
      merged
    }
  }
`;

export default formSubmissionFrag;
